/** Performs an array.splice(), returning the result without modifying the original array */
export const spliced = <T>(list: T[], start: number, deleteCount: number, ...items: T[]) => {
  const nextList = list.slice();
  nextList.splice(start, deleteCount, ...items);
  return nextList;
};
